module.exports = __webpack_public_path__ + "assets-cabinet/img/notification-icon.4b40a63c.svg";